<template>
  <div class="country-region-profile-nav">
    <countries-nav :selectMultiple="!$store.state.covid19.is_enabled || this.countries.length > 0" :closeOnSelect="false" :countries="countries" :toggleable="false" :closed="false"></countries-nav>
  </div><!-- /.country-region-profile-nav -->
</template>

<script>
import CountriesNav from './../CountriesNavigation/Nav'

export default {
  name: 'country-region-profile-navigation',
  components: {
    'countries-nav': CountriesNav
  },
  computed: {
    countries () { return this.$store.state.rsc.all }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/navigation/PageSidebarNavigation/CountryRegionProfile.vue